<mat-card *ngIf="seguimentTecnicData && seguimentTecnicData.projectData">
     <mat-toolbar style="width:100%;" color="secondary">
      {{(seguimentTecnicData.projectData.titol | slice:0:120)+"..."}}
      <div style="width:100%;float:right">
        <button matTooltip="{{'facturacio.toolbar.anarTreballToolTip' | translate }}" attr.aria-label="{{ 'facturacio.toolbar.anarTreballToolTip' | translate }}" matTooltipClass="tooltip-style" type="button" style="float: right; margin-left:10px;margin-right: 0" mat-icon-button (click)="this.goProject()">
           <mat-icon color="primary" style="font-size:24px">assignment</mat-icon>
        </button>
        <button mat-icon-button matTooltip="{{ 'seguimentTecnic.toolbar.exportarToolTip' | translate }}" attr.aria-label="{{ 'seguimentTecnic.toolbar.exportarToolTip' | translate }}" matTooltipClass="tooltip-style" (click)="this.export()" style="float: right; margin-left:10px;margin-right: 0">
           <mat-icon color="primary" style="font-size:24px">assignment_returned</mat-icon>
        </button>
        <button mat-icon-button (click)="addSeguimentTecnic()" color="primary" matTooltip="{{ 'seguimentTecnic.toolbar.afegirToolTip' | translate }}" attr.aria-label="{{ 'seguimentTecnic.toolbar.afegirToolTip' | translate }}" matTooltipClass="tooltip-style" style="float: right; margin-left:10px;margin-right: 0">
           <mat-icon color="primary" style="font-size:24px">note_add</mat-icon>
        </button>
     </div>
    </mat-toolbar>
    <mat-progress-bar mode="indeterminate" color="warm" *ngIf="showAsyncProgress" style="position: absolute;"></mat-progress-bar>
    <mat-card-content style="padding: 24px;">
      <h2 mat-line>{{ 'facturacio.titolDadesTreball' | translate }}</h2>
      <div class="dades-pressupost-import" style="background-color: #DDDDDD;padding:24px">
        <mat-form-field style="width: 80%">
         <input matInput placeholder="{{ 'propostaMi.camps.codi' | translate }}" name="codi" disabled
        [value]="seguimentTecnicData.projectData.codi"
       />
        </mat-form-field> 
        <mat-form-field style="width: 15%;min-width:200px">
         <input matInput placeholder="{{ 'facturacio.camps.empresa' | translate }}" name="empresa" disabled
        [value]="seguimentTecnicData.projectData.empresa"
       />
        </mat-form-field> 
        <mat-form-field style="width: 100px">
         <input matInput placeholder="{{ 'facturacio.camps.pressupostTotal' | translate }}" name="pressupostTotal" disabled
          [value]="seguimentTecnicData.projectData.pressupostTotal | number:'1.0-2'"
         />
        </mat-form-field> 
        <mat-form-field style="width: 140px">
         <input matInput placeholder="{{ 'facturacio.camps.pressupostContractat' | translate }}" name="pressupostContractat" disabled
          [value]="seguimentTecnicData.projectData.pressupostContractat | number:'1.0-2'"
         />
        </mat-form-field> 
        <mat-form-field style="width: 100px">
         <input matInput placeholder="{{ 'facturacio.camps.impostos' | translate }}" name="importImpostos" disabled
          [value]="seguimentTecnicData.projectData.importImpostos | number:'1.0-2'"
         />
        </mat-form-field> 
        <mat-form-field style="width: 100px">
         <input matInput placeholder="{{ 'facturacio.camps.garantia' | translate }}" name="importGarantia" disabled
          [value]="seguimentTecnicData.projectData.pressupostGarantia | number:'1.0-2'"
         />
        </mat-form-field> 
      </div>
    <h3 mat-line style="padding-top:20px">{{ 'seguimentTecnic.titolSeguiment' | translate }}</h3>
    <table style="padding-top:20px">
      <thead>
        <tr>
          <th style="width:20px"></th>
          <th style="width:100px;text-align: right">{{ 'seguimentTecnic.colData' | translate }}</th>
          <th style="width:80px;text-align: right">{{ 'propostaMi.camps.tipus' | translate }}</th>
          <th style="width:80px;text-align: right">{{ 'seguimentTecnic.colSubtipus' | translate }}</th>
          <th style="text-align: center">{{ 'seguimentTecnic.colAssumpte' | translate }}</th>
          <th style="width:150px;text-align: right">{{ 'seguimentTecnic.colAssistents' | translate }}</th>
          <th style="width:80px">&nbsp;</th>
        </tr>
      </thead>
      <tbody *ngIf="seguimentTecnicData.seguiments">
      <tr *ngFor="let seguiment of seguimentTecnicData.seguiments" >
        <td style="width:20px" *ngIf="seguiment.data < currentDate" title="{{ 'seguimentTecnic.finalitzadaTitle' | translate }}">(F)</td>
        <td style="width:20px" *ngIf="seguiment.data >= currentDate">&nbsp;</td>
        <td style="width:100px;text-align: right">
          {{seguiment.data | date}}&nbsp;
        </td>
        <td style="width:80px;text-align: right">
          {{languageService.label('seguimentTipusRaw', seguiment.tipus)}}&nbsp;
        </td>
        <td style="width:80px;text-align: right">
          {{languageService.label('seguimentsubTipusRaw', seguiment.sub_tipus)}}&nbsp;
        </td>        
        <td style="text-align: left">
          {{seguiment.assumpte}}&nbsp;
        </td>
        <td style="width:150px;text-align: right">
          {{seguiment.participants}}&nbsp;
        </td>
        <td style="width:85px">
          <button mat-icon-button title="{{ 'facturacio.editarTitle' | translate }}" color="primary"
           (click)="editSeguimentTecnic(seguiment)" style="margin-left:0px">
           <mat-icon>mode_edit</mat-icon>
          </button>
          <button mat-icon-button title="{{ 'facturacio.esborrarTitle' | translate }}" color="primary"
           (click)="deleteSeguimentTecnic(seguiment)" style="margin-left:0px">
           <mat-icon>delete_forever</mat-icon>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    </mat-card-content>
</mat-card>
